module.exports = __webpack_public_path__ + "img/maropost-logo.176fa12e.svg";